<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchool"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading || processing"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<!--Refresh Button-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--Add Sound-->
		<input id="AddSoundInput" name="AddSoundInput" type="file" accept=".mp3" style="display: none" (change)="onSoundToAddChange($event)" />
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Sound File</button>
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Sound</button>

		<!-- <button class="btn btn-primary" style="margin-left:5px;" (click)="onRecord()">Record Sound</button> -->

		<!--Can't Delete Sounds right now-->
		<!-- <button class="btn btn-primary" style="margin-left:5px;" (click)="onDelete()">Delete</button> -->

		<!--SoundLibrary doesn't have an active column but it will in the future-->
		<!-- <button class="btn btn-primary" style="margin-left:5px;" (click)="onToggleActive()">Toggle Active</button> -->

		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPlaySound()">Play Sound</button>
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onStopSound()">Stop Sound</button>
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onConvertAll()">
			Convert All .WAV files to .Mp3
		</button>
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onExport()">
			Export .Mp3 File
		</button>
		<button [disabled]="loading == true || processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onToggleActive()">
			{{ ToggleText }}
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[loading]="loading"
		[value]="lstSound"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSound"
		dataKey="SoundLibraryID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--Filter Sound Name-->
				<th>
					<p-columnFilter type="text" field="SoundName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Filter Duration-->
				<th></th>
				<!-- <th>
					<p-columnFilter type="numeric" field="Duration" matchMode="LESS_THAN" [showMenu]="true" aria-valuenow="0"></p-columnFilter>
				</th> -->
				<!--Date Dropdown-->
				<th></th>

				<!--Used By Dropdown-->
				<th>
					<p-columnFilter field="UsedBy" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUsedBy
								[ngModel]="value"
								[options]="lstUsedBy"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Defined By Dropdown-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Active Dropdown-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="SoundName">Sound Name<p-sortIcon field="SoundName"></p-sortIcon></th>
				<th pSortableColumn="DurationInt">Duration (Seconds)<p-sortIcon field="DurationInt"></p-sortIcon></th>
				<th pSortableColumn="SoundDT">Date<p-sortIcon field="SoundDT"></p-sortIcon></th>
				<th pSortableColumn="UsedBy">Used By<p-sortIcon field="UsedBy"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-sound>
			<tr [pSelectableRow]="sound">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ sound[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="sound.DefinedByID < 3 ? 'Red' : 'Black'">
					{{ sound["DefinedByDesc"] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="sound.Active == true ? 'Black' : 'Red'">
					{{ sound["ActiveDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="form-group top-Margin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
